<template>
  <div class="artwork-description">
    <author :author="artwork.author" />
    <hr />
    <div
      class="title d-flex justify-content-between justify-content-lg-around align-items-center"
    >
      <header class="d-flex flex-column align-items-lg-center">
        <h4 class="display-1 font-weight-bold text-lg-center m-0">
          {{ artwork.title }}
        </h4>
        <p class="m-0">
          <category :categories="artwork.categories" />
        </p>
        <time :datetime="artwork.created || new Date()" class="display-4 mt-2">
          Published :
          {{
            new Date(artwork.created || new Date()).toISOString().split("T")[0]
          }}
        </time>
      </header>
      <div class="hr-wrapper d-none d-lg-block w-100">
        <hr />
      </div>
      <div class="d-flex flex-column align-items-center">
        <b-btn disabled v-if="collecting">
          <font-awesome-icon
            slot="spinner"
            icon="spinner"
            color="white"
            pulse
          />
        </b-btn>
        <b-btn
          variant="red-hover"
          @click.prevent="collect(artwork)"
          v-else-if="artwork.collection"
        >
          Collected
        </b-btn>
        <b-btn variant="white-hover" @click.prevent="collect(artwork)" v-else>
          Collect
        </b-btn>
      </div>
    </div>
    <hr />
    <template v-if="artwork.tags.length">
      <div class="d-flex flex-column">
        <span class="display-1 mb-1">Tags</span>
        <div class="d-flex flex-wrap">
          <router-link
            :to="{
              name: 'gallery',
              params: {
                category: 'all',
                search: tag.name
              }
            }"
            class="tag mr-2 mb-1 px-2"
            :key="tag.id"
            v-for="tag in artwork.tags"
          >
            {{ tag.name }}
          </router-link>
        </div>
      </div>
      <hr />
    </template>
    <social
      name="artwork"
      :target="artwork"
      class="d-none d-lg-flex justify-content-around"
    ></social>
  </div>
</template>

<script>
import Author from "../components/Author";
import Category from "../components/Category";
import Social from "../components/Social";
import { Collection } from "../models";

export default {
  components: {
    Author,
    Category,
    Social
  },
  props: ["artwork"],
  data() {
    return {
      user: window.user,
      collecting: false
    };
  },
  methods: {
    async collect(artwork) {
      // window.user is {} when signed out, so check for an id.
      if (!this.user.id) {
        this.$router.push({
          name: "login",
          query: {
            redirect: this.$route.fullPath
          }
        });
        return;
      }

      this.collecting = true;
      if (artwork.collection) {
        await new Collection({
          id: artwork.collection
        }).delete();

        this.$set(artwork, "collection", null);
      } else {
        const { id } = await new Collection({
          artwork: artwork.id
        }).save();

        this.$set(artwork, "collection", id);
      }
      this.collecting = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/bootstrap-grid.scss";

.artwork-description {
  padding: 16px;
}

.title {
  @include media-breakpoint-up(lg) {
    flex-direction: column;
  }

  hr-wrapper {
    margin: 0 -32px;
  }
}

.tag {
  color: black;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  &:hover {
    color: black;
    border-color: black;
    text-decoration: none;
  }
}

hr {
  margin: 16px -16px;
}
</style>
